/**
 * This file specifies the state of the application in response to App actions
 */
import { fromJS } from 'immutable';
import Constants from '../../constants';

const { Auth, User } = Constants;

export const TOKEN_STORAGE_KEY = 'fashionnova_token_storage';

const initialState = fromJS({
  authToken: localStorage.getItem(TOKEN_STORAGE_KEY),
  isLoggedIn: !!localStorage.getItem(TOKEN_STORAGE_KEY),
  isSSOLoggedIn: !!localStorage.getItem(TOKEN_STORAGE_KEY),
  currentUser: fromJS({}),
});

/**
 * Returns and sets the next state based on the action passed to it
 *
 * @param {object} state state object that defaults to the initial state
 * @param {object} action action object containing action type and payload properties
 */
const appReducer = (state = initialState, action) => {
  switch (action.type) {
    case Auth.LOGIN_ERROR:
      localStorage.removeItem(TOKEN_STORAGE_KEY);
      return state
        .set('authToken', null)
        .set('isLoggedIn', false)
        .set('isSSOLoggedIn', false)
        .set('currentUser', fromJS({}));
    case Auth.SIGNUP_ERROR:
      localStorage.removeItem(TOKEN_STORAGE_KEY);
      return state.set('authToken', null).set('isLoggedIn', false);
    case Auth.LOGIN_SUCCESS:
      localStorage.setItem(TOKEN_STORAGE_KEY, action.token);
      return state
        .set('authToken', action.token)
        .set('isLoggedIn', true)
        .set('currentUser', fromJS(action.user));
    case Auth.SIGNUP_SUCCESS:
      localStorage.setItem(TOKEN_STORAGE_KEY, action.token);
      return state
        .set('authToken', action.token)
        .set('isLoggedIn', true)
        .set('currentUser', fromJS(action.user));
    case Auth.LOGOUT_SUCCESS:
      localStorage.removeItem(TOKEN_STORAGE_KEY);
      return state
        .set('authToken', null)
        .set('isLoggedIn', false)
        .set('isSSOLoggedIn', false)
        .set('currentUser', fromJS({}));
    case Auth.ONELOGIN_LOGOUT_SUCCESS:
      localStorage.removeItem(TOKEN_STORAGE_KEY);
      return state
        .set('authToken', null)
        .set('isLoggedIn', false)
        .set('isSSOLoggedIn', false)
        .set('currentUser', fromJS({}));
    case User.GET_CURRENT_USER_SUCCESS:
      localStorage.setItem(TOKEN_STORAGE_KEY, action.token);
      return state
        .set('authToken', action.token)
        .set('isLoggedIn', true)
        .set('currentUser', fromJS(action.user));
    case User.GET_CURRENT_USER_ERROR:
      localStorage.removeItem(TOKEN_STORAGE_KEY);
      return state
        .set('authToken', null)
        .set('isLoggedIn', false)
        .set('isSSOLoggedIn', false)
        .set('currentUser', fromJS({}));
    case User.GET_CURRENT_ONELOGIN_USER_SUCCESS:
      localStorage.setItem(TOKEN_STORAGE_KEY, action.token);
      return state
        .set('authToken', action.token)
        .set('currentUser', fromJS(action.user))
        .set('isSSOLoggedIn', true);
    case User.UPDATE_USER_SUCCESS:
      if (state.get('currentUser').toJS().role === 'ADMIN') {
        return state.set('user', fromJS(action.user));
      }
      return state
        .set('currentUser', fromJS(action.user))
        .set('user', fromJS(action.user));
    default:
      return state;
  }
};

export default appReducer;
